import React from 'react';
import {motion} from 'framer-motion';

const ServicesIntroSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="space-y-6 text-gray-700 font-inter leading-relaxed text-lg"
        >
          <p>
            Wherever you are in your journey — pre-divorce, during the process, or post-separation — I offer flexible services designed to work around you.
          </p>
          
          <p>
            Your first step is a free Discovery Call — a chance to talk through your current situation and explore how my support can help. You remain fully in control; you can use Divorce with Direction as much or as little as you need.
          </p>
          
          <p>
            Following your free call, your journey begins with a 60-minute Support Session, where we'll take a deeper look at your circumstances and identify the areas where you need the most support. After this, you can book further 1:1 sessions — either 60 or 30 minutes — focused on building a clear, tailored plan to help you move forward with confidence.
          </p>
          
          <p>
            Sessions can take place via Zoom or telephone, depending on your preference. For those living locally, I also offer face-to-face sessions for anyone who doesn't feel they have a private or safe space at home. After each session, you'll receive a personalised action plan, giving you clear steps to focus on between calls.
          </p>
          
          <p>
            Many clients also choose to add a package of ongoing support via email or WhatsApp. This gives you access to guidance and reassurance in real time — so when challenges or emotions arise, you're never left navigating them alone.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesIntroSection;